import { Login } from 'src/features/auth/components/templates/login';

export const LoginContainer = () => {
  return <Login />;
};
